import { Box, Flex, Text } from '@chakra-ui/react';
import { Tooltip } from '@chakra-ui/tooltip';
import { faFile, faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from '@morressier/alembic';
import { ISubmissionTagInfo } from '@publishing-engine/domain/views';
import { useState } from 'react';
import { TagDetails } from 'src/components/Submission/AuthorsTab/AuthorProfileModal/TagDetailsPopover';

const MAX_VISIBLE_TAGS = 3;

interface Props {
  id: string;
  tags: ISubmissionTagInfo['tags'];
  maxWidth?: string;
}

export const SubmissionTags: React.FC<Props> = ({ tags, id, maxWidth }) => {
  const [showAllTags, setShowAllTags] = useState<boolean>(false);
  const [showAllTagsId, setShowAllTagsId] = useState<string>('');

  return (
    <Flex gap={2} marginTop={1} maxWidth={maxWidth || '450px'} flexWrap="wrap">
      {!!tags?.length && (
        <>
          {tags
            .slice(
              0,
              showAllTags && showAllTagsId === id
                ? tags.length
                : MAX_VISIBLE_TAGS
            )
            .map(tag => (
              <Tooltip
                hasArrow
                key={tag.id}
                borderRadius={4}
                placement="top"
                background={'surfacePrimaryFill'}
                color={'neutralSecondaryContent'}
                label={<TagDetails tags={tag} />}
              >
                <Box width={'fit-content'}>
                  <Badge size="context" variant="neutral">
                    <Flex
                      gap={1}
                      alignItems="center"
                      color={'neutralSecondaryContent'}
                    >
                      <FontAwesomeIcon
                        icon={tag.usage === 'users' ? faUser : faFile}
                        color={tag.tagColor}
                      />
                      <Text textStyle="textContext" noOfLines={1} maxW="200px">
                        {tag.name}
                      </Text>
                    </Flex>
                  </Badge>
                </Box>
              </Tooltip>
            ))}
          {tags.length > MAX_VISIBLE_TAGS && (
            <Box>
              <Badge
                size="context"
                variant="neutral"
                onClick={() => {
                  setShowAllTags(prevValue => !prevValue);
                  setShowAllTagsId(id);
                }}
                cursor="pointer"
              >
                <Flex
                  gap={1}
                  alignItems="center"
                  color={'neutralSecondaryContent'}
                >
                  <Text textStyle="textContext">
                    {showAllTags && showAllTagsId === id
                      ? 'Show Less'
                      : `+${tags.length - MAX_VISIBLE_TAGS} more`}
                  </Text>
                </Flex>
              </Badge>
            </Box>
          )}
        </>
      )}
    </Flex>
  );
};
